/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('productionByFlightsCtrl', productionByFlightsCtrl);

    productionByFlightsCtrl.$inject = ['tabs', 'userSession', 'type', 'flightService', 'productionService', 'linkService',
        'dateService', 'printService', 'userService', 'excelService', 'datePickerService'];

    function productionByFlightsCtrl(tabs, userSession, type, flightService, productionService, linkService, dateService,
                                     printService, userService, excelService, datePickerService) {
        var vm = this;
        vm.tabs = tabs;
        vm.flights = [];
        vm.type = type;
        // vm.pages = paginationService.getPages();
        vm.isReport = false;
        vm.eventFlights = eventFlights;
        vm.reportProductionDetailTotalHtml = '';
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(userSession.data.positionType);
        vm.filterProduction = {
            detail: true,
            fromDate: new Date(),
            toDate: null,
            flight: null
        };

        eventFlights();

        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            },
            closed: function(args) {
                var days = (vm.type === 'notFlown') ? 31 : 31;
                var dateAux = new Date(args.closeDate);
                var maxDate = new Date(dateAux.setDate(dateAux.getDate() + days));
                vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
                if (vm.type === 'productionByFlights') {
                    eventFlights();
                }
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: new Date()
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.cancel = function() {
            linkService.reloadRoute(type, null);
        };

        vm.generate = function (isValid) {
            if(isValid) {
                var fromDate, toDate;
                if (vm.type === 'productionByFlights') {
                    if (vm.filterProduction.detail) {
                        productionService.getProductionDetailByFlight(vm.filterProduction.flight.departureFlightIds)
                            .then(function (response) {
                                onSuccess(response);
                            });
                    } else {
                        fromDate = dateService.dateTimeString(vm.filterProduction.fromDate, 1);
                        toDate = dateService.dateTimeString(vm.filterProduction.toDate, 1);
                        productionService.getProductionTotalByFlight(fromDate, toDate)
                            .then(function (response) {
                                onSuccess(response);
                            });
                    }
                } else if (vm.type === 'flown') {
                    fromDate = dateService.dateTimeString(vm.filterProduction.fromDate, 1);
                    toDate = dateService.dateTimeString(vm.filterProduction.toDate, 1);
                    productionService.getFlownPerformance(fromDate, toDate)
                        .then(function (response) {
                            onSuccess(response);
                        });
                } else if (vm.type === 'notFlown') {
                    fromDate = dateService.dateTimeString(vm.filterProduction.fromDate, 1);
                    toDate = dateService.dateTimeString(vm.filterProduction.toDate, 1);
                    productionService.getNotFlown(fromDate, toDate)
                        .then(function (response) {
                            onSuccess(response);
                        });
                }
            }
        };

        vm.generatePdfHtml = function (target) {
            printService.printPdfHtml(target);
        };

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'production_report');
        };

        function onSuccess(response) {
            vm.reportProductionDetailTotalHtml = response.data;
            vm.isReport = true;
        }

        function eventFlights(){
            if(vm.filterProduction.fromDate !== undefined){
                vm.flights= [];
                flightService.getFlightsFromDate(vm.filterProduction.fromDate.getTime())
                    .then(function (response) {
                      var flights = (response.data._embedded) ? response.data._embedded.flights : [];
                        angular.forEach(flights, function(flight){
                            var departureFlightIds = '';
                            angular.forEach(flight._embedded.departureflights, function(departureFlight, index) {
                                if (flight._embedded.departureflights.length === 1) {
                                    departureFlightIds = departureFlightIds + 'departureFlightIds=' + linkService.getLinkId(departureFlight._links.self.href);
                                } else {
                                    if (index === 0) {
                                        departureFlightIds = departureFlightIds + 'departureFlightIds=' + linkService.getLinkId(departureFlight._links.self.href);
                                    } else {
                                        departureFlightIds = departureFlightIds + '&departureFlightIds=' + linkService.getLinkId(departureFlight._links.self.href);
                                    }
                                }
                            });
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials,
                                departureFlightIds: departureFlightIds
                            });
                        });
                    });
            }
        }
    }

})();
